import { render } from "./UserHistory.vue?vue&type=template&id=6c881ffa&scoped=true&ts=true"
import script from "./UserHistory.vue?vue&type=script&lang=ts"
export * from "./UserHistory.vue?vue&type=script&lang=ts"

import "./UserHistory.vue?vue&type=style&index=0&id=6c881ffa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c881ffa"]])

export default __exports__